export default __webpack_public_path__ + "fonts/UpsideDown-White.svg";